var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapGeoNoFons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 38 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ttn8203yaa",
    width: "139.5%",
    height: "139.5%",
    x: "-19.7%",
    y: "-19.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "eanzs2r6sc"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.431372 0 0 0 0 0.384314 0 0 0 0 0.349020 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "tpt7urraqb",
    cx: 19,
    cy: 19,
    r: 19
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-317.000000, -358.000000) translate(317.000000, 358.267041)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ttn8203yaa)",
    xlinkHref: "#tpt7urraqb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#tpt7urraqb"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    filter: "url(#eanzs2r6sc)",
    transform: "translate(8.142857, 8.142857)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.857,
    cy: 10.857,
    r: 3.619
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.262 9.952h-2.315c-.42-3.767-3.417-6.766-7.185-7.184V.452c0-.25-.202-.452-.452-.452h-.905c-.25 0-.453.202-.453.452v2.316c-3.768.418-6.766 3.417-7.184 7.184H.452c-.25 0-.452.203-.452.453v.904c0 .25.202.453.452.453h2.316c.418 3.768 3.416 6.766 7.184 7.185v2.315c0 .25.203.452.453.452h.905c.25 0 .452-.202.452-.452v-2.315c3.768-.42 6.766-3.417 7.185-7.185h2.315c.25 0 .452-.202.452-.453v-.904c0-.25-.202-.453-.452-.453zM10.857 17.19c-3.492 0-6.333-2.84-6.333-6.333 0-3.492 2.841-6.333 6.333-6.333s6.333 2.84 6.333 6.333c0 3.492-2.841 6.333-6.333 6.333z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 25.786,
    cy: 25.786,
    r: 3.167,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA322A",
    fillRule: "nonzero",
    d: "M25.786 20.81c-2.748 0-4.976 2.226-4.976 4.973 0 2.75 2.228 4.979 4.976 4.979 2.749 0 4.976-2.229 4.976-4.979 0-2.747-2.227-4.973-4.976-4.973zm.355 7.742c-.116.103-.25.155-.402.155-.157 0-.294-.051-.41-.153-.118-.102-.176-.244-.176-.426 0-.162.056-.299.17-.41.113-.11.252-.165.416-.165.162 0 .299.055.41.166.11.11.165.247.165.409 0 .18-.058.321-.173.424zm1.44-3.573c-.088.165-.194.307-.316.427s-.341.32-.658.603c-.087.08-.157.15-.21.21-.053.061-.092.116-.118.167-.026.05-.045.1-.06.15-.013.05-.035.138-.063.264-.049.268-.202.402-.46.402-.133 0-.245-.044-.337-.131-.091-.088-.137-.218-.137-.39 0-.216.034-.403.1-.561.067-.159.156-.298.267-.417.11-.12.26-.262.447-.427.165-.144.284-.252.357-.326.074-.073.135-.155.185-.245.05-.09.075-.187.075-.293 0-.206-.076-.38-.229-.52-.153-.142-.35-.213-.592-.213-.283 0-.492.072-.626.214-.133.143-.246.353-.339.631-.088.29-.254.436-.498.436-.144 0-.265-.05-.364-.152-.1-.102-.149-.212-.149-.33 0-.244.079-.492.235-.743.157-.25.386-.458.687-.623.301-.165.653-.247 1.054-.247.373 0 .702.069.987.207.286.137.506.324.662.561.156.237.234.494.234.772 0 .218-.044.41-.133.574z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapGeoNoFons);
export default __webpack_public_path__ + "static/media/map-geo-no-fons.bdbe1e30.svg";
export { ForwardRef as ReactComponent };